import { _x } from '@wordpress/i18n'
import type { BaseHit, Hit } from 'instantsearch.js'
import { useEffect } from 'react'
import HitComponent from './HitComponent'
import NoResults from './NoResults'
import SearchEasterEgg from '../../../../assets/frontend/js/easterEggs/SearchEasterEgg'
import { scrollIntoView } from '../../../../assets/frontend/js/utils/dom'

type HitListProps = {
  layout: 'card' | 'list'
  items: Hit<BaseHit>[]
}

function HitList({ layout, items }: HitListProps) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Only way
  useEffect(() => {
    const widget = document.querySelector('.sermons-list')
    const filterPanel = widget?.querySelector('.filter-panel')
    const isStickyFilter = filterPanel?.classList.contains('is-sticky')
    if (!widget || !isStickyFilter) return
    scrollIntoView(widget as HTMLElement, { offset: 10 })
  }, [items])

  if (items.length === 0) {
    return (
      <>
        <SearchEasterEgg source="sermons-list" noResults />
        <NoResults />
      </>
    )
  }

  return (
    <>
      <SearchEasterEgg source="sermons-list" noResults={false} />
      {layout === 'card' ? (
        <div className="grid">
          {items.map((item) => (
            <div
              key={item.objectID}
              className="g-col g-col-12 g-col-md-6 g-col-lg-4"
            >
              <HitComponent hit={item} variant="card" />
            </div>
          ))}
        </div>
      ) : layout === 'list' ? (
        <div className="space-y-2">
          {items.map((item) => (
            <div key={item.objectID}>
              <HitComponent hit={item} variant="list" />
            </div>
          ))}
        </div>
      ) : null}
    </>
  )
}

export default HitList
